module.exports = __webpack_public_path__ + "card-DC.png?b93df58152b26666d1b47b1c3db15c40";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/card-DC.png
// module id = 203
// module chunks = 0